import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import ContentTagForm from './ContentTagForm';

export default function NewContentTagScreen() {
  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Create New Content Tag"
          items={[
            { name: 'Library Content', url: '/library' },
            { name: 'Content Tags', url: '/library/content-tags' },
            { name: 'Create' },
          ]}
        />

        <ContentTagForm />
      </Stack>
    </ScreenWrap>
  );
}
